import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { District, School, Sport, State } from 'types'
import { DEFAULT_TITLE_FONT_SIZE, FEATURE_NAME, IState } from '../Init.model'

const initialState: IState = {
  title: null,
  titleFontSize: DEFAULT_TITLE_FONT_SIZE,
  state: null,
  district: null,
  school: null,
  sport: null,
}

export const initSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setWidgetTitle(state, action: PayloadAction<string | null>) {
      state.title = action.payload
    },
    setWidgetTitleFontSize(state, action: PayloadAction<number>) {
      state.titleFontSize = action.payload
    },
    setFilterState(state, action: PayloadAction<State>) {
      state.state = action.payload
    },
    setFilterDistrict(state, action: PayloadAction<District | null>) {
      state.district = action.payload
    },
    setFilterSchool(state, action: PayloadAction<School>) {
      state.school = action.payload
    },
    setFilterSport(state, action: PayloadAction<Sport>) {
      state.sport = action.payload
    },
  },
})

export const {
  setWidgetTitle,
  setWidgetTitleFontSize,
  setFilterState,
  setFilterDistrict,
  setFilterSchool,
  setFilterSport,
} = initSlice.actions
